import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LifecycleManagementUpsertEventRequestDto } from "@lib/ShiOneClient";
import { ASSET_LIFECYCLE_QUERY_KEYS } from "../constants";
import { LifecycleManagementClient } from "@lib/ShiOneClient";
import { ApiClientConfig } from "auth/ApiClientConfig";

function useUpdateAssetLifecycleEventData() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      uniqueId,
      status,
      strategy,
      customerFacingNotes,
      manualOverrideEventDate,
      clearManualOverrideEventDate,
      customerOwner,
      initialValue,
    }: {
      uniqueId: string;
      status?: string;
      strategy?: string;
      customerFacingNotes?: string;
      manualOverrideEventDate?: string;
      clearManualOverrideEventDate?: boolean;
      customerOwner?: string[];
      initialValue: LifecycleManagementUpsertEventRequestDto;
    }) => {
      const api = new LifecycleManagementClient(
        ApiClientConfig,
        import.meta.env.API_ENDPOINT,
      );
      const request = {
        uniqueIdentifier: uniqueId,
        status: status,
        strategy: strategy,
        customerFacingNotes: customerFacingNotes,
        manualOverrideEventDate: manualOverrideEventDate,
        clearManualOverrideEventDate: clearManualOverrideEventDate,
        customerOwner: customerOwner,
        initialValue: initialValue,
      } as LifecycleManagementUpsertEventRequestDto;
      return await api.putEvent(request);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ASSET_LIFECYCLE_QUERY_KEYS.grid],
      });
    },
  });
}

export default useUpdateAssetLifecycleEventData;
